import React from "react";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/content";

export default function Testimonials() {
    return (
        <section
            id="reviews"
            data-testid="testimonials-section"
            className="py-24 md:py-32 bg-[#faf9f6]"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-12">
                <div className="max-w-2xl mb-14">
                    <div className="text-xs uppercase tracking-[0.3em] text-[#7a8582] flex items-center">
                        <span className="gdc-divider" />
                        Patient stories
                    </div>
                    <h2 className="font-serif-display mt-4 text-4xl md:text-5xl leading-tight text-[#1a1d1c]">
                        Kind words from
                        <br />
                        <span className="italic text-[#114b5f]">
                            our smiling patients.
                        </span>
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {TESTIMONIALS.map((t, i) => (
                        <figure
                            key={t.name}
                            data-testid={`testimonial-${i}`}
                            className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border border-[#e8e4db] relative"
                        >
                            <Quote
                                size={28}
                                className="absolute top-6 right-6 text-[#d4af37]/60"
                                strokeWidth={1.25}
                            />
                            <div className="flex items-center gap-1 mb-4">
                                {Array.from({ length: t.rating }).map((_, j) => (
                                    <Star
                                        key={j}
                                        size={14}
                                        strokeWidth={1.5}
                                        className="fill-[#d4af37] text-[#d4af37]"
                                    />
                                ))}
                            </div>
                            <blockquote className="text-lg md:text-xl text-[#1a1d1c] leading-relaxed">
                                “{t.quote}”
                            </blockquote>
                            <figcaption className="mt-6 text-sm text-[#4a5250]">
                                <span className="font-medium text-[#1a1d1c]">
                                    {t.name}
                                </span>{" "}
                                · {t.location}
                            </figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
